import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import { getUser } from 'services/refresh';
const DefalutData: any = {
  name: ''
};

const slice = createSlice({
  name: 'user',
  initialState: DefalutData,
  reducers: {
    setUser: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...payload };
    }
  }
});
export const userStore = (state: RootState) => state.user;
export const { setUser } = slice.actions;
export default slice.reducer;

export const getUserInfo = async () => {
  try {
    let res: any = await getUser();
    const { data = {} } = res || {};
    if (data?.code === '2000') {
      store.dispatch(setUser(data?.data));
    }
    return Promise.resolve(res);
  } catch (error) {}
};
